<template>
	<div class="message-bubble cart-container">
		<v-card>
			<v-card-title primary-title>
				Su Carrito
			</v-card-title>
			<v-card-text>
				<v-container>
					<v-row dense>
						<v-col cols="9" class="font-weight-bold">
							Producto
						</v-col>
						<v-col cols="3" class="font-weight-bold">
							Precio
						</v-col>
					</v-row>
					<v-divider></v-divider>
					<v-row
						:class="{ 'cart-row': true, 'row-differencer': index % 2 == 0 }"
						v-for="(item, index) in cart"
						:key="index"
						dense
					>
						<v-col cols="9" class="font-weight-bold">
							{{ item.qtt }} - {{ item.name }}
						</v-col>
						<v-col cols="2" class="font-weight-bold">
							${{ item.price * item.qtt }}
						</v-col>
						<v-col cols="1">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										color="error"
										text
										icon
										v-bind="attrs"
										v-on="on"
										@click="remove(index, item)"
									>
										<v-icon>mdi-close</v-icon>
									</v-btn>
								</template>
								<span>
									Remover
								</span>
							</v-tooltip>
						</v-col>
						<v-col cols="12" v-if="item.observation"
							>Observacion: {{ item.observation }}</v-col
						>
					</v-row>
					<v-row class="cart-row" dense>
						<v-col cols="9" class="font-weight-bold">
							Total
						</v-col>
						<v-col>
							{{ total }}
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<BackBtn return_to="catalogue" :text="true" />
				<v-spacer></v-spacer>
				<v-btn
					class="bot-btn-action button-rounding"
					@click="choose_delivery"
					v-if="cart.length > 0"
					:disabled="loadingCart"
				>
					<v-icon left>mdi-credit-card</v-icon>
					Comprar
				</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>
import BackBtn from "./BackBtn";
export default {
	components: {
		BackBtn,
	},
	computed: {
		user() {
			return this.$store.getters["chatStore/get_user"];
		},
		loadingCart() {
			return this.$store.getters["chatStore/loadingCart"]
		},
		cart() {
			let res = [];
			if (this.$store.getters["chatStore/get_cart"].products) {
				res = [
					...res,
					...this.$store.getters["chatStore/get_cart"].products.map((i) => ({
						...i,
						type: "products",
					})),
				];
			}

			if (this.$store.getters["chatStore/get_cart"].extras) {
				res = [
					...res,
					...this.$store.getters["chatStore/get_cart"].extras.map((i) => ({
						...i,
						type: "extras",
					})),
				];
			}

			return res;
		},
		total() {
			let total = 0;
			this.cart.forEach((item) => {
				total += parseFloat(Number(item.price)) * item.qtt;
			});
			return `$${total}`;
		},
	},
	methods: {
		remove(index, item) {
			this.$store.commit("chatStore/UPDATE_CART", { item, index });
			this.$store.dispatch("chatStore/delete_cart_item", {
				pid: item.id,
				type: item.type,
				name: item.name,
			});
		},
		choose_delivery() {
			if (!this.user) {
				this.$store.commit("chatStore/STATUS", "check-email");
				return;
			}
			this.$store.commit("chatStore/STATUS", "choose-delivery");
		},
		banks() {
			this.$store.commit("chatStore/STATUS", "banks");
		},
	},
};
</script>

<style lang="scss">
.cart-row {
	&:not(:last-child) {
		border-bottom: 1px solid #eee;
	}
	&:hover {
		background-color: #eee;
	}
	.v-btn {
		height: unset;
	}
}
.row-differencer {
	background-color: #fefefe;
}
</style>
